import { Link } from 'react-router-dom';
import { Shell } from '../components/Shell';
import './NotFoundPage.css';

export function NotFoundPage() {
  return (
    <Shell>
      <div className="wi-notfound">
        <p className="wi-notfound-kicker">404</p>
        <h1 className="wi-notfound-title">This page isn’t here</h1>
        <p className="wi-notfound-lede">
          The link may be outdated, or the address was mistyped. Try the home page or explore modules and journeys.
        </p>
        <div className="wi-notfound-actions">
          <Link to="/" className="wi-notfound-primary">
            Go home
          </Link>
          <Link to="/browse" className="wi-notfound-secondary">
            Browse library
          </Link>
          <Link to="/journeys" className="wi-notfound-secondary">
            Journeys
          </Link>
        </div>
      </div>
    </Shell>
  );
}
